// removed by extract-text-webpack-plugin
module.exports = {"btnCommonTouchable":"style__btnCommonTouchable___IrvQf","btnActiveTouchable":"style__btnActiveTouchable___2KFzH"};


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/canvas/ui/components/bar-toggler/style.css
// module id = 1365
// module chunks = 0